// `SystemConfig.*` i18n keys — the SuperAdmin-only global system configuration page.

export const systemConfigDict: Record<string, [en: string, th: string]> = {
  "SystemConfig.pageTitle": ["System Config", "ตั้งค่าระบบ"],
  "SystemConfig.breadcrumb": ["System Config", "ตั้งค่าระบบ"],
  "SystemConfig.title": ["System Configuration", "การตั้งค่าระบบ"],
  "SystemConfig.subtitle": ["Global settings — SuperAdmin only", "การตั้งค่าส่วนกลาง — เฉพาะ SuperAdmin"],
  "SystemConfig.importSection": ["Data Import", "การนำเข้าข้อมูล"],
  "SystemConfig.backupBeforeImport": ["Backup data before import", "สำรองข้อมูลก่อนนำเข้า"],
  "SystemConfig.backupBeforeImportHint": [
    "When enabled, the company's wines, receipts and bottles are snapshotted before each import so they can be restored.",
    "เมื่อเปิดใช้งาน ระบบจะสำรอง ไวน์/ใบรับ/ขวด ของบริษัทก่อนการนำเข้าแต่ละครั้ง เพื่อให้กู้คืนได้",
  ],
  "SystemConfig.save": ["Save", "บันทึก"],
  "SystemConfig.saved": ["Settings saved", "บันทึกการตั้งค่าแล้ว"],
  "SystemConfig.loadFailed": ["Failed to load system config", "โหลดการตั้งค่าระบบไม่สำเร็จ"],
  "SystemConfig.saveFailed": ["Failed to save system config", "บันทึกการตั้งค่าระบบไม่สำเร็จ"],
};
